import { ModuleKey } from './hooks/use-rich-input';

export type ActionModule = ModuleKey | 'gif' | 'include-giver' | 'privacy' | 'video-recording' | 'audio-recording';
export type { Editor } from '@tiptap/react';

export enum ActionInputContextType {
	Recognition = 'recognition',
	Comment = 'comment',
	TemplatedAward = 'templated-award',
	NonTemplatedAward = 'non-templated-award',
}
